import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  text: {
    fontSize: 14,
    margin: "4px 0px",
  },
  partnerRole: {
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
